import React, { useEffect, useRef } from 'react';

interface TallyFormProps {
  embedUrl: string;
  className?: string;
  title?: string;
  subtitle?: string;
}

const TallyForm: React.FC<TallyFormProps> = ({ 
  embedUrl, 
  className = "",
  title = "Register for this event",
  subtitle = "Secure your spot today"
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Clear any existing content
    containerRef.current.innerHTML = '';

    // Create iframe
    const iframe = document.createElement('iframe');
    iframe.setAttribute('data-tally-src', embedUrl);
    iframe.setAttribute('loading', 'lazy');
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', '412');
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('marginheight', '0');
    iframe.setAttribute('marginwidth', '0');
    iframe.setAttribute('title', 'Lead generation form');
    iframe.style.border = 'none';
    iframe.style.borderRadius = '8px';

    // Create script
    const script = document.createElement('script');
    script.textContent = `
      var d=document,w="https://tally.so/widgets/embed.js",v=function(){"undefined"!=typeof Tally?Tally.loadEmbeds():d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((function(e){e.src=e.dataset.tallySrc}))};if("undefined"!=typeof Tally)v();else if(d.querySelector('script[src="'+w+'"]')==null){var s=d.createElement("script");s.src=w,s.onload=v,s.onerror=v,d.body.appendChild(s);}
    `;

    // Append elements
    containerRef.current.appendChild(iframe);
    containerRef.current.appendChild(script);

    // Cleanup function
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [embedUrl]);

  return (
    <div className={`bg-white rounded-lg shadow-lg p-6 ${className}`}>
      <div className="text-center mb-6">
        <h3 className="text-xl font-semibold text-brand-darkgrey mb-2">
          {title}
        </h3>
        <p className="text-brand-grey text-sm">
          {subtitle}
        </p>
      </div>
      
      {/* Tally form will be embedded here */}
      <div ref={containerRef} className="min-h-[412px]"></div>
      
      <div className="text-center mt-4">
        <p className="text-xs text-brand-grey">
          By registering, you agree to receive communications from us.
        </p>
      </div>
    </div>
  );
};

export default TallyForm;

